import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";

export const Page5 = () => {
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
        <p className="para" style={{ margin: "15px 0" }}>
          Training & Onshore Deployment –
        </p>
        <p className="para">
          On selection for Onshore deployment, you will be required to undergo
          training and subsequently you must enter into a bond / agreement with
          the Company. A separate agreement will be executed before deploying
          for onshore assignments. On signing the agreement, you will agree to
          stay with the company for a period of two years, failing which you
          will be liable to pay Rs. 50000/- as costs incurred by the Company for
          training, visa processing, etc.
        </p>
        <p className="bolds" style={{ margin: "15px 0" }}>
          Certificates / Testimonials:
        </p>
        <p className="para">
          At the time of your joining the Company you are required to submit
          copies of all your past and present academic and career credentials,
          if applicable, together with all the necessary documents as mentioned
          in the Offer Letter.
        </p>
        <p className="para">
          The Company reserves the right to terminate your employment in the
          event – You fail to furnish copies of certificates of your
          qualifications and experiences and / or of not receiving satisfactory
          references and certificates from your previous employers, if any, as
          regards to your satisfactory performances and conduct
        </p>
        <p className="para" style={{ marginTop: "15px" }}>
          Separation:
        </p>
        <p className="para">
          If you wish to resign your employment with the Company, you will be
          required to provide 60 days’ written notice to enable us to transition
          your work. You may alternatively be required to pay Company the notice
          period charges due for any short notice, solely at the discretion of
          the Company. This stands applicable during your Probation and after
          your confirmation of employment.
        </p>
        <p className="para">
          The Company may terminate your employment without cause at any time by
          providing you with the minimum notice of 60 days or compensate you the
          basic pay in lieu of such notice and any severance pay if applicable
          and eligible and no more.
        </p>
        <p className="para">
          Notwithstanding what is stated above, your appointment maybe
          terminated forthwith without any notice or payment of any kind in case
          of:
        </p>
        <ul style={{ margin: "10px 40px" }} className="para">
          <li style={{paddingLeft:"15px"}}>Repeated willful insubordination or disobedience</li>
          <li style={{paddingLeft:"15px"}}>Proven Theft, Fraud or Dishonesty</li>
          <li style={{paddingLeft:"15px"}}>Willful damage or loss of Company’s property</li>
          <li style={{paddingLeft:"15px"}}>
            Consistent and prolonged Absence from work Or Irregularity to work
            inspite of repeated warnings
          </li>
          <li style={{paddingLeft:"15px"}}>
            Any accusation or allegations against you under Sexual Harassment of
            Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013
          </li>
          <li style={{paddingLeft:"15px"}}>
            Criminal Accusation, proven guilty or convicted by any Court of Law
            during the tenure of your service with the Company.
          </li>
          <li style={{paddingLeft:"15px"}}>Being declared medically unfit to work</li>
        </ul>
      </div>
    </ReusablePDFLayout>
  );
};
